import {OrderStatusEnum} from "../enums/OrderStatusEnum";

export function convertPendingToExpires(status: string): string {
    if (status.toUpperCase() === OrderStatusEnum.PENDING) {
        return "Expires";
    }
    return status;
}
